import { useEffect, useState } from "react";

import { getSupabaseClient } from "@/components/atomic-crm/providers/supabase/supabase";

// Sprint 4 T4.3 — Hook minimal pour récupérer l'utilisateur auth courant
// (uuid + email) côté frontend. useGetIdentity() de ra-core ne retourne
// que { id (sales.id), fullName, avatar, administrator } — pas l'email
// dont on a besoin pour le mapping role-by-email dans TodayPage.
//
// Future opportunity: BriefDailyBanner has similar getUser logic that
// could use this hook (deferred to avoid scope creep T4.3).

export type AuthUser = {
  id: string;
  email?: string;
};

export function useAuthUser(): AuthUser | null {
  const [user, setUser] = useState<AuthUser | null>(null);

  useEffect(() => {
    let cancelled = false;
    getSupabaseClient()
      .auth.getUser()
      .then(({ data }) => {
        if (cancelled) return;
        setUser(
          data.user ? { id: data.user.id, email: data.user.email } : null,
        );
      })
      .catch(() => {
        if (!cancelled) setUser(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return user;
}
